import 'favicon.ico'
import 'intl'
import 'intl/locale-data/jsonp/en'
import React from 'react'
import { render } from 'react-dom'
import AppRouter from './shell/AppRouter'

render(
  <AppRouter />,
  document.getElementById('app-container')
)

if ('ActiveXObject' in window) {
  document.body.classList.add('browser-ie')
}



// WEBPACK FOOTER //
// ./src/client/index.js